import { object, string, TypeOf } from 'zod';

/* ----------------------------- PairingResponse ---------------------------- */

export const PairingResponse = object({
    device: object({
        id: string(),
        platform: string(),
    }),
    wantsToPurchase: string().optional(),
});

export type PairingResponse = TypeOf<typeof PairingResponse>;
